import React from 'react';
import LookupDialog from './lookup-dialog';

export default function LookupPage() {
  return <LookupDialog open />;
}
